module.exports = {
          srcSet: __webpack_public_path__ + "884685204ef7f45aa92b8717aca6873e-32.png"+" 32w",
          images:[ {path: __webpack_public_path__ + "884685204ef7f45aa92b8717aca6873e-32.png",width: 32,height: 32}],
          src: __webpack_public_path__ + "884685204ef7f45aa92b8717aca6873e-32.png",
          toString:function(){return __webpack_public_path__ + "884685204ef7f45aa92b8717aca6873e-32.png"},
          
          width: 32,
          height: 32
        }